import React, { useState, useRef, useEffect, useCallback, } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Box, } from '@material-ui/core';
import Moment from 'moment'
import { useDispatch, } from 'react-redux';
import {
  Header,
  Overview,
  FinancialStats,
} from './components';
import { showSnackbar, } from 'actions'
import { fetchEarnings, } from 'firebaseHelpers/parkings'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  container: {
    '& > *': {
      height: '100%'
    }
  }
}));

const Earnings = (props) => {
  const { parkingId, } = props

  const classes = useStyles();
  const dispatch = useDispatch();

  const isCancelled = useRef(false)
  const [from, setFrom] = useState(Moment().startOf('month'))
  const [to, setTo] = useState(Moment().endOf('month'))
  // const [isLoading, setIsLoading] = useState(false)
  const [earningsInfos, setEarningsInfos] = useState({ totalBookings: 0, totalIncome: 0, data: [] })

  const fetchData = useCallback(async (parkingId) => {
    try {
      // setIsLoading(true)
      const earningsFetched = await fetchEarnings(from, to, parkingId)
      if (!isCancelled.current) {
        // setIsLoading(false)
        setEarningsInfos(earningsFetched)
      }
    } catch (error) {
      // setIsLoading(false)
      dispatch(showSnackbar({ variant: 'error', message: error.message }))
    }
  }, [from, to, dispatch])

  const setDate = (dateLabel, date) => {
    if (dateLabel === 'from') {
      setFrom(date)
    } else if (dateLabel === 'to') {
      setTo(date)
    }
  }

  useEffect(() => {
    isCancelled.current = false
    fetchData(parkingId)

    return () => {
      isCancelled.current = true
    }
  }, [ parkingId, from, to, fetchData, ]);

  return (
    <Box
      className={classes.root}
    >
      <Header from={from} to={to} setDate={setDate}/>
      <Grid
        className={classes.container}
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
        >
          <Overview totalIncome={earningsInfos.totalIncome} totalBookings={earningsInfos.totalBookings}/>
        </Grid>
        <Grid
          item
          lg={12}
          xl={12}
          xs={12}
        >
          <FinancialStats earningsInfos={earningsInfos.data}/>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Earnings;
